import { Scaled, ThemedProps, ThemeType } from '../types';

export const scale = (theme: ThemeType, scalar = 1) =>
    theme.unit * scalar;

export const applyUnit = ({ theme, size = 1 }: ThemedProps<Scaled>) =>
    scale(theme, size) + `px`;
